import React from "react";
import Modal from "../../commonComponents/util/Modal";
import Select from "../../commonComponents/util/Select";
import FadeOutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";

import { exportCSVFile } from "../../../lib/utils";

function getReportFields() {
  return [
    { label: "Last Name/Org Name", value: "LastOrOrgName", default: "" },
    { label: "First Name", value: "FirstName", default: "" },
    { label: "Title", value: "Title", default: "" },
    { label: "Report Name", value: "ReportName", default: "" },
    { label: "Address", value: "Address", default: "" },
    { label: "City", value: "City", default: "" },
    { label: "State", value: "State", default: "" },
    { label: "Zip", value: "Zip", default: "" },
    { label: "Country", value: "Country", default: "" },
    { label: "Phone Number(s)", value: "PhoneNumbers", default: "" },
    { label: "Campaign List(s)", value: "CampaignLists", default: "" },
    { label: "Categories", value: "Categories", default: "" },
    { label: "Position", value: "Position", default: "" },
    { label: "Reference(s)", value: "References", default: "" },
    { label: "Solicitor(s)", value: "Solicitors", default: "" },
    { label: "Rosh Yeshiva(s)", value: "RoshYeshivas", default: "" },
    { label: "Teudat Zehut", value: "TeudatZehut", default: "" },
    { label: "Bank Info", value: "BankAccountInfo", default: "" },
    { label: "Bank Account Holder", value: "BankAccountHolder", default: "" },
  ];
}

const initialState = {
  fields: [],
  groupBy: "",
  error: false,
  noData: false,
  downloading: false,
  submitAttempted: false
};

export default class ReportModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  onChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onToggleReportFields = event => {
    const fieldName = event.target.name;
    const checked = event.target.checked;

    let fields = [...this.state.fields];
    if (checked) {
      fields.push(fieldName);
    } else {
      fields = fields.filter(f => f !== fieldName);

      if (this.state.groupBy === fieldName) {
        this.setState({ groupBy: "" });
      }
    }

    this.setState({ fields });
  };

  close() {
    this.setState(initialState);
    this.props.close();
  }

  async exportData() {
    this.setState({
      error: false,
      noData: false,
      submitAttempted: true
    });

    const { fields, groupBy } = this.state;

    if (!fields.length) {
      return;
    }

    this.setState({
      downloading: true
    });

    try {
      const dateNow = `${new Date().toLocaleDateString().replace(/\//g, "_")}`;

      const reportFields = getReportFields();

      let params = {
        fields,
        groupBy
      };
      let exportHeaders = reportFields.filter(
        field => fields.indexOf(field.value) >= 0
      );
      let reportName = this.props.reportName || `${this.props.campaignListName}_${dateNow}`;

      const response = await this.props.getDataForExport(params);

      if (!response.success) throw Error("error");

      const records = response.data.values;

      if (!records.length) throw Error("noData");

      exportHeaders = exportHeaders.map(({ getValue, ...header }) => ({
        ...header,
        value: getValue || header.value
      }));

      exportCSVFile(exportHeaders, records, reportName);

      this.setState({ downloading: false }, this.close);
    } catch (error) {
      this.setState({ downloading: false, [error.message || "error"]: true });
    }
  }

  render() {
    const {
      error,
      fields,
      groupBy,
      downloading,
      noData,
      submitAttempted
    } = this.state;

    const {
      show
    } = this.props;

    const reportFields = getReportFields();

    return (
      <Modal modalShowing={show}>
        <div className="modal-container">
          <div className="modal new-fund-modal large-modal">
            <div className="bordered-modal-header">
              <h4 className="modal-page-header">
                Campaign List Report
              </h4>
              <i
                className="icon ion-ios-close-empty"
                onClick={this.close.bind(this)}
              />
            </div>
            <div className="modal-section">
              <div className="mb-16">
                <div className="flex">
                  <label
                    className={`input-label ${
                      submitAttempted && !fields.length ? "error-label" : ""
                      }`}
                  >
                    Report Fields
                  </label>
                  {submitAttempted && !fields.length && (
                    <span className="xs-text error-text ml-8">
                      * Please select report fields
                    </span>
                  )}
                </div>
                <div className="modal-row report-fields-grid">
                  {reportFields.map(field => (
                    <div className="custom-check-container" key={field.value}>
                      <input
                        type="checkbox"
                        id={`report-field-${field.value}`}
                        className="custom-check"
                        name={field.value}
                        onChange={this.onToggleReportFields}
                        checked={fields.indexOf(field.value) >= 0}
                      />
                      <label
                        htmlFor={`report-field-${field.value}`}
                        className="secondary-text"
                      >
                        {field.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="modal-row">
                <div className="column-half column-half-left">
                  <label className="input-label">
                    Remove Duplicates Of
                  </label>
                  <Select
                    clearable={true}
                    options={reportFields
                      .filter(field => fields.indexOf(field.value) >= 0)
                      .map(field => ({
                        key: field.value,
                        value: field.label
                      }))}
                    value={groupBy}
                    name="groupBy"
                    onChange={e =>
                      this.onChange(e.target.name, e.target.value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="modal-btns text-right">
              <button
                className="btn btn-accent"
                onClick={this.close.bind(this)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={this.exportData.bind(this)}
                disabled={downloading}
              >
                {downloading ? "Downloading Report" : "Download Report"}
              </button>
              <FadeOutErrorMessage show={error} />
              <FadeOutErrorMessage
                show={noData}
                message="No data was found."
                timeOut={5000}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/CampaignListReportModal.jsx